module.exports = __webpack_public_path__ + "static/img/school2.0d30320.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/school2.png
// module id = lwoE
// module chunks = 6